import React, { useEffect, useState } from "react";
import {
  GetDeleteClientApi,
  GetDeleteOrganizerApi,
  RestoreDeletedClient,
  RestoreDeletedOrganizer,
} from "../../../api/request/settings/restoreUser";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/settings/restoreUser";
import moment from "moment";
import Restore from "../../../assets/Restore";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import toast from "react-hot-toast";
import MySegmented from "../../../components/segmented/Segmented";

const RestoreUser = () => {
  const [userData, setUserData] = useState([]);
  const [organizerData, setOrganizerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isRestoreOpen, setIsRestoreOpen] = useState(false);
  const [isRestoreLoading, setIsRestoreLoading] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [segmentedValue, setSegmentedValue] = useState("Client");

  const IsSegmentClient = segmentedValue === "Client";
  const getDeleteUser = async () => {
    try {
      setIsLoading(true);
      const getApi = IsSegmentClient
        ? GetDeleteClientApi()
        : GetDeleteOrganizerApi();
      const { data } = await getApi;
      if (data?.status) {
        setUserData(
          data?.data?.map((item) => {
            return {
              ...item,
              mobile: item?.mobile_no,
              status: (
                <p
                  className={`${
                    item?.status === "active"
                      ? "text-green-500"
                      : "text-red-500"
                  } font-semibold`}
                >
                  {item?.status === "active" ? "ACTIVE" : "INACTIVE"}
                </p>
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("LL")
                : "",
              deleted_at: item?.created_at
                ? moment(item?.created_at).format("LL")
                : "",
              action: (
                <button
                  onClick={() => {
                    setIsRestoreOpen(true);
                    setSelectedId(item?.id);
                  }}
                >
                  <Restore />
                </button>
              ),
            };
          })
        );
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const getDeleteOrganizer = async () => {
    try {
      setIsLoading(true);
      const getApi = IsSegmentClient
        ? GetDeleteClientApi()
        : GetDeleteOrganizerApi();
      const { data } = await getApi;
      if (data?.status) {
        setOrganizerData(
          data?.data?.map((item) => {
            return {
              ...item,
              mobile: item?.mobile_no,
              status: (
                <p
                  className={`${
                    item?.status === "active"
                      ? "text-green-500"
                      : "text-red-500"
                  } font-semibold`}
                >
                  {item?.status === "active" ? "ACTIVE" : "INACTIVE"}
                </p>
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("LL")
                : "",
              deleted_at: item?.created_at
                ? moment(item?.created_at).format("LL")
                : "",
              action: (
                <button
                  onClick={() => {
                    setIsRestoreOpen(true);
                    setSelectedId(item?.id);
                  }}
                >
                  <Restore />
                </button>
              ),
            };
          })
        );
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleRestoreUser = async () => {
    try {
      setIsRestoreLoading(true);
      const params = { client_id: selectedId };
      const { data: response } = await RestoreDeletedClient(params);
      if (response?.status) {
        toast.success(response?.message);
        setIsRestoreOpen(false);
        setUserData(userData.filter((item) => item.id !== selectedId));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsRestoreOpen(false);
    } finally {
      setIsRestoreLoading(false);
    }
  };

  const handleRestoreOrganizer = async () => {
    try {
      setIsRestoreLoading(true);
      const params = { organizer_id: selectedId };
      const { data: response } = await RestoreDeletedOrganizer(params);
      if (response?.status) {
        toast.success(response?.message);
        setIsRestoreOpen(false);
        setOrganizerData(organizerData.filter((item) => item.id !== selectedId));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsRestoreOpen(false);
    } finally {
      setIsRestoreLoading(false);
    }
  };

  useEffect(() => {
    getDeleteUser();
    getDeleteOrganizer();
  }, [segmentedValue]);

  return (
    <>
      <div className="mb-2">
        <MySegmented
          options={["Client", "Organizer"]}
          value={segmentedValue}
          setValue={setSegmentedValue}
        />
      </div>

      <div className="border-2 rounded-xl mb-4">
        <SkeletonTable
          searchingFields={["name", "email"]}
          dateFilterFields={["created_at", "deleted_at"]}
          columns={columns}
          data={IsSegmentClient ? userData : organizerData}
          isLoading={isLoading}
          pagination={true}
        />
      </div>

      {/* ------ Confirmation modal for restore user and organizer ------- */}
      <ConfirmationModal
        type="success"
        isOpen={isRestoreOpen}
        setIsOpen={setIsRestoreOpen}
        message={`Are you sure, you want to restore ${
          IsSegmentClient ? "client" : "organizer"
        }?`}
        onConfirm={IsSegmentClient ? handleRestoreUser : handleRestoreOrganizer}
        isLoading={isRestoreLoading}
        loadingLabel={`Restoring ${
          IsSegmentClient ? "client" : "organizer"
        }...`}
      />
    </>
  );
};

export default RestoreUser;
